module.exports = {"653024100":"乌恰镇","653024101":"康苏镇","653024102":"巴音库鲁提镇","653024200":"乌鲁克恰提乡","653024201":"吾合沙鲁乡","653024202":"膘尔托阔依乡","653024203":"黑孜苇乡","653024204":"托云乡","653024205":"铁列克乡","653024207":"波斯坦铁列克乡","653024208":"吉根乡","653024501":"兵团托云牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653024.json
// module id = 3246
// module chunks = 0